import React, { Component } from "react";
import { Redirect, BrowserRouter, Route, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Sidebar, Segment, Menu } from "semantic-ui-react";
import * as AppActions from "../../actions";
import FormsContainer from "../FormsContainer";
import FormContainer from "../FormContainer";
import Drafts from "../DraftsContainer";
import Approvals from "../ApprovalsContainer";
import Outbox from "../OutboxContainer";
import { messaging } from "../../init-fcm";
import SentItems from "../SentItemsContainer";
import Settings from "../SettingsContainer";
import Tasks from "../TasksContainer";
import SideBar from "../../components/SideBar";
import Logout from "../Logout";
import LoginContainer from "../LoginContainer";
import "./App.css";
import "./input_informed.css";
import "./semantic_informed.css";
import "./menu_informed.css";
import "./list_informed.css";
import "./icon_informed.css";
import "./progress_informed.css";
import "./custom.css";
import _ from "lodash";

class App extends Component {
  constructor(props) {
    super(props);

    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > 0
    ) {
      console.log("IE");
    } else {
      document.documentElement.style.setProperty(
        "--main-bg-color",
        window.shadeBlendConvert(0.2, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--thumb-bg-color",
        window.shadeBlendConvert(0.8, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--itemHover-bg-color",
        window.shadeBlendConvert(-0.2, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--pagesNumber-bg-color",
        window.shadeBlendConvert(0.6, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--optional-bg-color",
        window.shadeBlendConvert(0.6, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--sort-bg-color",
        window.shadeBlendConvert(0.4, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--sortSelected-bg-color",
        window.shadeBlendConvert(0.9, this.props.storeColour)
      );
    }

    if (!this.props.isLoggedIn) {
      this.props.history.push("/login");
    }
    this.state = {
      width: 800,
      height: 182
    };
  }

  componentDidUpdate() {
    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > 0
    ) {
      console.log("IE");
    } else {
      document.documentElement.style.setProperty(
        "--main-bg-color",
        window.shadeBlendConvert(0.2, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--thumb-bg-color",
        window.shadeBlendConvert(0.8, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--itemHover-bg-color",
        window.shadeBlendConvert(-0.2, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--pagesNumber-bg-color",
        window.shadeBlendConvert(0.6, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--optional-bg-color",
        window.shadeBlendConvert(0.6, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--sort-bg-color",
        window.shadeBlendConvert(0.4, this.props.storeColour)
      );
      document.documentElement.style.setProperty(
        "--sortSelected-bg-color",
        window.shadeBlendConvert(0.9, this.props.storeColour)
      );
    }
  }
  componentDidMount() {
    this.updateDimensions();
    ReactDOM.findDOMNode(this).scrollIntoView();
    var isConnected = navigator.onLine ? true : false;
    this.props.actions.connectionState(isConnected);
    window.addEventListener("online", this.updateOnlineStatus.bind(this));
    window.addEventListener("offline", this.updateOnlineStatus.bind(this));

    let thisx = this;
    try {
      messaging
        .requestPermission()
        .then(async function() {
          const token = await messaging.getToken();
          if (token) {
            thisx.props.actions.setDeviceToken(token);
          }
        })
        .catch(function(err) {
          console.log("Unable to get permission to notify.", err);
        });

      messaging.onMessage(payload => {
        this.props.actions.receivedNotification(payload.data.id);
        this.props.actions.getNotifications(1, false);
      });

      navigator.serviceWorker.addEventListener("message", message => {});
    } catch (e) {}
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus.bind(this));
    window.removeEventListener("offline", this.updateOnlineStatus.bind(this));
  }

  updateOnlineStatus(event) {
    var isConnected = navigator.onLine ? true : false;
    this.props.actions.connectionState(isConnected);

    let storeid = this.props.storeId;
    let test = this.props.test;
    var q = _.filter(this.props.actionQueue, function(f) {
      return (
        f.storeId === storeid &&
        (f.isDraft === false || (f.isDraft && !f.saved)) &&
        f.test === test
      );
    });

    var formCount = q.length;

    if (isConnected && formCount > 0) {
      this.syncForms();
    }
  }

  syncForms(uuids) {
    var q = _.filter(this.props.actionQueue, {
      storeId: this.props.storeId,
      test: this.props.test
    });
    q.forEach(form => {
      if ((form.isDraft && !form.saved) || !form.isDraft) {
        this.props.actions.submitFormDoQ(
          form.draftName,
          this.props.sessionId,
          form.form_id,
          form.form_version,
          form.draft,
          this.props.deviceId,
          form.uuid,
          form.isDraft,
          form.result_id,
          form.latitude,
          form.longitude
        );
      }
    });
  }

  updateDimensions() {
    let update_width = window.innerWidth;
    let update_height = window.innerHeight;
    this.setState({ width: update_width, height: update_height });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const different =
      this.props.submitted === nextProps.submitted && this.props.submitted;

    return different;
  }

  render() {
    const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={props =>
          this.props.isLoggedIn === true ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          )
        }
      />
    );

    let y = this.state.height - 150 + "px";

    return (
      <BrowserRouter>
        <div>
          <Sidebar.Pushable as={Segment} className="sidebar-container">
            <SideBar></SideBar>
            <Sidebar.Pusher style={{ height: y }}>
              <Segment basic>
                <PrivateRoute exact path="/forms" component={FormsContainer} />
                <PrivateRoute
                  exact
                  path="/form/:form_id/:uuid/:approver/:recovered/:form_title/:form_version/:result_id?/:notification_id?/:isDraft?/:outbox?/"
                  component={FormContainer}
                />
                <PrivateRoute
                  path={"/settings"}
                  title="Settings"
                  component={Settings}
                />
                <PrivateRoute
                  path="/outbox"
                  title="Outbox"
                  component={Outbox}
                />
                <PrivateRoute
                  path="/drafts"
                  title="Drafts"
                  component={Drafts}
                />
                <PrivateRoute
                  path="/approvals"
                  title="Approvals"
                  component={Approvals}
                />
                <PrivateRoute
                  path="/sent"
                  title="Sent Items"
                  component={SentItems}
                />
                <PrivateRoute
                  path="/tasks"
                  title="Tasks"
                  component={Tasks}
                />
                <PrivateRoute path="/logout" component={Logout} />
                <Route path="/login" component={LoginContainer} />
              </Segment>
            </Sidebar.Pusher>
          </Sidebar.Pushable>
        </div>
      </BrowserRouter>
    );
  }
}

App.propTypes = {
  sidebarVisibility: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  storeLogo: PropTypes.string.isRequired,
  storeColour: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sidebarVisibility: state.informedWebApp.sidebarVisibility,
  storeLogo: state.informedWebApp.storeLogo,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  storeId: state.informedWebApp.storeId,
  storeColour: state.informedWebApp.storeColour,
  isLoggedIn:
    state.informedWebApp.sessionId !== "" &&
    state.informedWebApp.authenticated === true
      ? true
      : false,
  deviceId: state.informedWebApp.deviceId,
  sessionId: state.informedWebApp.sessionId,
  actionQueue: state.informedWebApp.actionQueue,
  submitted: state.form.submitted,
  imageQueue: state.informedWebApp.imageQueue
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/containers/App/App.js